import { EndpointCall, retrieve } from "components/http/endpoint";
import { ApiUriPrefix } from "../apiUriPrefix";


const ClubsApiUri = ApiUriPrefix + "clubs";

function apiGetClub(id: number): EndpointCall {
    const uri = `${ClubsApiUri}/${id}`;
    return retrieve(uri, null);
}

export {
    apiGetClub,
}
